import { BannerDIYFormItem } from './banner-diy-form-item';
import { BannerSize } from './banner-size';

export class VersioningMakeOS {
  approvedExport: string;
  editableFields: any[];
  previewSize: BannerSize;
  originalData: any;
  previewFrames: number[];

  constructor(data: any) {
    this.approvedExport = typeof data.approvedExport !== 'undefined' ? data.approvedExport : '';
    this.editableFields =
      typeof data.editableFields !== 'undefined' && Array.isArray(data.editableFields)
        ? [...data.editableFields.map((r: any) => new BannerDIYFormItem(r))]
        : [];
    this.previewSize = new BannerSize(data.previewSize);
    this.previewFrames = typeof data.previewFrames !== 'undefined' ? data.previewFrames : [];
    this.originalData = Object.assign({}, data);
  }
}
